<template>
<section class="content">
  <div class="box box-info">
    <div class="container-fluid">
      <div class="row p-mt-3">
        <div class="col-md-7">
          <DataTable :value="salesItemList" :paginator="true" :rows="5" editMode="cell" class="editable-cells-table">
            <Column header="Item" field="itemName" />
            <Column header="Qty" field="quantity" bodyStyle="width:50%">
              <template #body="slotProps">
                <InputNumber onfocus="if (this.value === '0')
                                    this.value = ''" v-model="slotProps.data[slotProps.column.field]" 
                                    showButtons buttonLayout="horizontal" style="width: 3em;" 
                                    decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" 
                                    incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus" :min="0" :max="100" />
              </template>
            </Column>
            <Column header="Rate" field="sellingPrice" >
            <template #body="slotProps" >
              <InputNumber v-if="enableRateEdit"  onfocus="if (this.value === '0')
                                    this.value = ''" v-model="slotProps.data.sellingPrice"  />
                                    
              <InputNumber  v-else disabled onfocus="if (this.value === '0')
                                    this.value = ''" v-model="slotProps.data.sellingPrice"  />
                                    </template>
                                    
            </Column>
            <Column header="Total">
              <template >
                <!-- {{slotProps.data.sellingPrice * slotProps.data.quantity}} -->
                 <InputNumber   onfocus="if (this.value === '0')
                                    this.value = ''" {{slotProps.data.sellingPrice  * slotProps.data.sellingPrice}}  />
              </template>
            </Column>
            <Column header="Action">
              <template #body="slotProps">
                <Button icon="pi pi-trash" class="p-button-danger p-button-text"
                @click="removeItemFromList(slotProps.index)" />
              </template>
            </Column>
          </DataTable>
          <div style="display:none">{{findTotalQuantity}}{{findDueAmt}}{{calculateTotal}}</div>
          <Card class="p-mt-3 p-mb-3">
            <template #content>
              <div>Total Quantity: <label class="p-ml-4">{{totalQuantity }}</label></div>
              <hr>
              <!-- <div>Discount:
                <Button v-if="chooseDiscountAmt" @click="chooseDisountAmt" label="Rs" />
                <Button v-if="chooseDiscountPer" @click="chooseDisPercent" label="%" />
                <InputNumber onfocus="if (this.value === '0')
                                    this.value = ''" v-if="chooseDiscountAmt" placeholder="Discount Amount" v-model="discountAmt" />
                <InputNumber onfocus="if (this.value === '0')
                                    this.value = ''" v-if="chooseDiscountPer" v-model="discountPer" placeholder="Discount Per" />
              </div> -->
              <!-- <hr> -->
              <!-- <div>
                Discount Amt:<label class="p-ml-4">{{'Rs. '+discountAmt}}</label>
              </div> -->
              <!-- <hr/> -->
              <div>Sub Total:<label class="p-ml-4">{{'Rs. '+subTotal}}</label></div>

              <!-- <hr>
              <div>Vat: <label class="p-ml-4">{{vat +' %'}}</label></div>
              <hr> -->
              <hr>
              <div>Total:<label class="p-ml-4">{{'Rs. '+totalBillAmount}}</label></div>
              <hr>
            </template>
          </Card>
          <div class="p-fluid p-formgrid p-grid">
            <!-- <div class="p-field p-col-12 p-md-4">
              <label>Customer Name:</label>
              <InputText placeholder="Customer Name" v-model="customerName" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label>Contact Number:</label>
              <InputText onfocus="if (this.value === '0')
                                this.value = ''" v-model="contactNumber" id="contactNum"/>
            </div>
            <div class="p-field p-col-12 p-md-12">

            </div> -->
            <div class="p-field p-col-12 p-md-12">
              <label>Tender Amount:</label>
              <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" mode="decimal" :minFractionDigits="2" v-model="tenderAmount" />
            </div>
            <div class="p-field p-col-12 p-md-12">
              <h4 v-if="dueAmount < 0">Return Amount: <b style="color:red;">{{'Rs. '+dueAmount}}</b></h4>
              <h4 v-if="dueAmount > 0">Return Amount: <b style="color:green;">{{'Rs. '+dueAmount}}</b></h4>
              <h4 v-if="dueAmount === 0">Return Amount: <b style="color:grey;">{{'Rs. '+dueAmount}}</b></h4>
            </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="status1">Pay By:</label>
                <RadioButton id="status1" name="Cash" value="CASH" v-model="paymentMethod" />
                <label for="status1" class="p-mr-3">Cash</label>
                <RadioButton id="status2" name="Esewa" value="ESEWA" v-model="paymentMethod" />
                <label for="status2">Esewa</label>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="status1">Paid Status:</label>
                <RadioButton id="status1" name="paid" value="PAID" v-model="paymentStatus" />
                <label for="status1" class="p-mr-3">Paid</label>
                <RadioButton id="status2" name="unpaid" value="UNPAID" v-model="paymentStatus" />
                <label for="status2">Unpaid</label>
              </div>
              <div class="p-field p-col-12 p-md-6" v-if="paymentStatus==='UNPAID'">
                <label for="address">Address:</label>
                <InputText v-model="address" id="address"/>
              </div>
               <div class="p-field p-col-12 p-md-6" v-if="paymentStatus==='UNPAID'">
                <label for="delivery">Delivery Amount:</label>
                <InputText v-model="deliveryCharge" id="delivery"/>
              </div>
              <div class="p-field p-col-12 p-md-6" v-if="paymentStatus==='UNPAID'">
                <label for="remarks">Remarks:</label>
                <InputText v-model="remarks" id="remarks"/>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <Button label="Submit" @click.prevent="savePOSEntry" class=" p-mt-4 p-button-success" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <Button label="Cancel" class=" p-mt-4 p-button-danger" />
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <DataView :value="displayItemList" :paginator="true" :rows="6" :layout="layout">
            <template #header>
              <div class="p-grid p-nogutter">
                <!-- <div> -->
                <div class="p-field p-col-12 p-md-6">
                  <RadioButton id="barcode" name="Barcode" value="Barcode" v-model="searchByBarcode"  />
                  <label for="barcode" class="p-mr-3">Barcode</label>
                  <RadioButton id="search" name="Search" value="Search" v-model="searchByBarcode" @change="focusOnPageLoad" />
                  <label for="search">Search</label>
                </div>
                <InputText v-model="searchTerm" v-show="searchByBarcode==='Search'"  placeholder="Please enter keyword"  @input="searchItemWithUserInput"/>
                <InputText v-model="searchTerm" v-show="searchByBarcode === 'Barcode'" @keypress.enter="searchItem($event)" ref="searchbar" placeholder="Barcode" />
                <!-- </div> -->
              </div>
            </template>
            <template #grid="slotProps">
              <div class="p-col-6 p-md-4">
                <div class="product-grid-item card">
                  <div class="product-grid-item-top">
                    <div>
                      <i class="pi pi-tag product-category-icon"></i>
                      <span class="product-category">{{slotProps.data.groupName}}</span>
                    </div>
                  </div>
                  <div class="product-grid-item-content">
                    <a href="" @click.prevent="addItemToList(slotProps.data)">
                      <img :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name" style="height: 100px;width: 100px;"/></a>
                    <div class="product-name">{{slotProps.data.name}}</div>
                    <!-- <div class="product-description">{{slotProps.data.description}}</div> -->
                  </div>
                  <div class="product-grid-item-bottom">
                    <span class="product-price" style="float: right;margin: 0em 0.3em;">Rs.{{slotProps.data.salesRate}}</span>
                     <Button class="p-button-secondary" badge="8" icon="pi pi-shopping-cart"  @click.prevent="addItemToList(slotProps.data)" >
                    </Button>
                    <span class="product-price" icon="pi pi-shopping-cart" >{{slotProps.data.closingStock}}</span>
                   
                  </div>
                </div>
              </div>
            </template>
          </DataView>
        </div>
      </div>
    </div>
  </div>
    <Dialog
    :visible.sync="printDialog"
    header="Do you want to print this bill?"
    :style="{width: '35vw'}"
    :modal="true"
    :closable="false"
    >
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" @click="printBill" label="Yes" icon="pi pi-check"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-danger" @click="closePrintDialog" icon="pi pi-times" label="No"/>
        </div>
       </div>
    </Dialog>
</section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DataView from 'primevue/dataview'
import Card from 'primevue/card'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Dialog from 'primevue/dialog'
export default {
  name: 'PointofSales',
  data() {
    return {
      itmQty: 1,
      displayItemList: [],
      salesItemList: [],
      layout: 'grid',
      salesItem: {},
      paymentMethod: 'CASH',
      totalQuantity: 0,
      searchTerm: '',
      tenderAmount: 0,
      dueAmount: 0,
      subTotal: 0,
      vat: 13,
      totalBillAmount: 0,
      customerName: '',
      contactNumber: 0,
      chooseDiscountPer: false,
      chooseDiscountAmt: true,
      discountPer: 0,
      discountAmt: 0,
      searchByBarcode: 'Search',
      printDialog: false,
      dataToPrint: {},
      paymentStatus: 'PAID',
      address: '',
      deliveryCharge: 0,
      total: 0
    }
  },
  mounted() {
    this.itemsList()
    this.checkEditRate()
  },
  computed: {
    findTotalQuantity() {
      this.totalQuantity = 0
      this.subTotal = 0
      if (this.salesItemList.length > 0) {
        for (let i = 0; i < this.salesItemList.length; i++) {
          this.totalQuantity += parseFloat(this.salesItemList[i].quantity)
          // // debugger
          // console.log(this.salesItemList[i].quantity)
          if (this.salesItemList[i].quantity !== null) {
            this.subTotal += parseFloat(this.salesItemList[i].sellingPrice) * parseFloat(this.salesItemList[i].quantity)
          }
          if (isNaN(this.discountAmt)) {
            this.discountAmt = 0
          }
          if (this.chooseDiscountPer === true) {
            if (this.discountPer > 100) {
              this.$toast.add({
                severity: 'error',
                summary: '',
                detail: 'Discount must be less than 100 %',
                life: 10000
              })
              return
            }
            if (this.discountAmt === '') {
              this.discountAmt = 0
            }
            this.discountAmt = (parseFloat(this.subTotal) * this.discountPer / 100)
            // this.discountPer = (parseFloat(this.discountAmt) / parseFloat(this.subTotal)) * 100
          }
          this.totalBillAmount = parseFloat(this.subTotal) - parseFloat(this.discountAmt)
          if (isNaN(this.totalQuantity)) {
            this.totalQuantity = 0
          }
          if (isNaN(this.totalBillAmount)) {
            this.totalBillAmount = this.subTotal
          }
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt > this.subTotal) {
              // // debugger
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'Discount Amount must be less than total Amount!',
              life: 10000
            })
            return
          }
            // // debugger
          if (this.discountAmt === null) {
            this.discountAmt = 0
          }
          if (isNaN(this.discountAmt)) {
            this.discountAmt = 0
          }
            // this.discountAmt = (parseFloat(this.subTotal) * this.discountPer / 100)
        }
      }
    },
    calculateTotal() {
      if (this.rate === 0) {
        if (this.total > 0 && this.quantity > 0) {
          // eslint-disable-next-line no-unused-vars
          let rates = 0
          rates = parseFloat(this.total) / parseFloat(this.quantity)
          if (isNaN(rates)) {
            rates = 0.00
          }
          this.rate = rates.toFixed(2)
          return rates
        }
      }
    },
    findDueAmt() {
      if (this.tenderAmount == null) {
        this.tenderAmount = 0
      }
      if (this.tenderAmount >= 0) {
        this.dueAmount = parseFloat(this.tenderAmount) - parseFloat(this.totalBillAmount)
      }
    }
  },
  methods: {
    async itemsList() {
      let response = await this.$store.dispatch('loadItemMasterList')
      this.displayItemList = response.data.data
      this.focusOnPageLoad()
    },
    addItemToList(data) {
      if (data !== undefined) {
        if (data.quantity === undefined) {
          data.quantity = this.itmQty
        }
        let item = {
          itemId: data.id,
          itemName: data.name,
          sellingPrice: data.salesRate,
          quantity: data.quantity,
          vatType: data.vatType
        }
        if (this.salesItemList.length > 0) {
          let found = this.salesItemList.find(obj => obj.itemId === data.id)
          if (found === undefined) {
            this.salesItemList.push(item)
          } else {
            if (found.itemId === data.id) {
              found.quantity = found.quantity + 1
              // console.log('gere')
            }
          }
        } else {
          this.salesItemList.push(item)
        }
      }
      this.focusOnPageLoad()
    },
    removeItemFromList(index) {
      this.salesItemList.splice(index, 1)
      if (this.salesItemList.length === 0) {
        this.reset()
        this.itemsList()
      }
      this.focusOnPageLoad()
    },
    searchItem(event) {
      // // debugger
      if (this.searchByBarcode === 'Barcode') {
        this.displayItemList = this.displayItemList.filter(item => {
          return item.fullQrCode.includes(this.searchTerm)
        })
        this.salesItem = this.displayItemList[0]
        if (this.salesItem === undefined) {
          this.searchTerm = ''
          this.itemsList()
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'No item available!',
            life: 10000
          })
          return
        }
        // // debugger
        // console.log(event.code)
        if (event.code === 'Enter') {
          // console.log('coming here?')
          this.addItemToList(this.salesItem)
        }
        this.searchTerm = ''
        if (this.searchTerm === '') {
          this.itemsList()
        }
      }
    },
    searchItemWithUserInput () {
      // // debugger
      if (this.searchByBarcode === 'Search') {
        let filteredItemList = this.displayItemList.filter(item => {
          return item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
        this.displayItemList = filteredItemList
        if (filteredItemList.length !== 0) {
          this.salesItem = filteredItemList[0]
        }
        if (this.searchTerm === '') {
          this.itemsList()
        }
      }
    },
    async savePOSEntry() {
      // if (this.tenderAmount === null || this.tenderAmount === 0) {
      //   this.$toast.add({
      //     severity: 'warn',
      //     summary: '',
      //     detail: 'Tender Amount cannot not be 0!',
      //     life: 3000
      //   })
      //   return
      // }
      if (this.salesItemList.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'No Item available!',
          life: 3000
        })
        return
      }
      // if (this.dueAmount < 0) {
      //   this.$toast.add({
      //     severity: 'warn',
      //     summary: '',
      //     detail: 'You have due amount left!',
      //     life: 3000
      //   })
      //   return
      // }
      if (this.contactNumber === '' || this.contactNumber === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'Please provide contact number!',
          life: 3000
        })
        return
      }
      let posItem = {
        customerName: this.customerName,
        contactNumber: this.contactNumber,
        discountAmount: this.discountAmt,
        discountPercentage: this.discountPer,
        billAmount: this.totalBillAmount,
        returningAmount: this.dueAmount,
        tenderAmount: this.tenderAmount,
        paymentMethod: this.paymentMethod,
        paymentStatus: this.paymentStatus,
        deliveryAddress: this.address,
        childSalesDetailsDTOList: this.salesItemList,
        deliveryAmount: this.deliveryCharge,
        remarks: this.remarks
      }
      let response = await this.$store.dispatch('savePOSEntry', posItem)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: response.data.message,
          life: 3000
        })
        this.reset()
        this.openPrintDialog(response.data.data)
      }
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    },
    focusOnPageLoad() {
      if (this.searchByBarcode === 'Search') {
        this.$nextTick(function() {
          this.$refs.search.$el.focus()
        })
      }
    },
    openPrintDialog(data) {
      this.printDialog = true
      this.dataToPrint = data
    },
    printBill() {
      this.printDialog = false
      if (this.paymentStatus === 'UNPAID') {
        // // debugger
        this.$router.push({name: 'posDeliveryPrint', params: { printData: this.dataToPrint }})
      } else {
        this.$router.push({name: 'posPrintPage', params: { printData: this.dataToPrint }})
      }
    },
    checkEditRate() {
      if (this.$store.getters.modules.includes(',7.12')) {
        this.enableRateEdit = true
      }
    },
    closePrintDialog() {
      this.printDialog = false
      this.itemsList()
    },
    reset() {
      this.totalQuantity = 0
      this.tenderAmount = 0
      this.subTotal = 0
      this.dueAmount = 0
      this.totalBillAmount = 0
      this.discountAmt = 0
      this.vat = 0
      this.searchTerm = ''
      this.customerName = ''
      this.contactNumber = 0
      this.salesItemList = []
      this.customerName = ''
      this.contactNumber = ''
      this.address = ''
      this.deliveryCharge = 0
      this.remarks = ''
    }
  },
  components: {
    DataTable,
    Column,
    DataView,
    Card,
    Button,
    InputText,
    RadioButton,
    InputNumber,
    InputMask,
    Dialog
  }
}
</script>
<style scoped>
.product-category {
  font-weight: 600;
  vertical-align: middle;
}

.product-grid-item {
  margin: .5rem;
  border: 1px solid #dee2e6;
}

.layout-content .card {
  background: var(--surface-e);
  padding: 2rem;
  -webkit-box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  margin-bottom: 2rem;
}

.product-grid-item .product-grid-item-content {
  text-align: center;
}

.product-name {
  font-size: 1.2rem;
  font-weight: 700;
}

.product-description {
  margin: 0 0 1rem 0;
}

.product-grid-item .product-price {
  font-size: 1.2rem;
  font-weight: 600;
}

.product-grid-item img {
  /* width: 75%; */
  -webkit-box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  margin: 2rem 0;
}
.p-datatable .p-datatable-tbody>tr>td.p-cell-editing .p-component {
  width: -1% !important
}
</style>



// WEBPACK FOOTER //
// nocPosSales.vue?a6374fda